module.exports = __webpack_public_path__ + "static/media/Pain.b2f9b300.svg";